/******/ (() => {
  // webpackBootstrap
  var __webpack_exports__ = {};

  Shopify.theme.jsAjaxCart = {
    init: function ($section) {
      // Add settings from schema to current object
      Shopify.theme.jsAjaxCart = $.extend(
        this,
        Shopify.theme.getSectionData($section)
      );

      if (isScreenSizeLarge() || this.cart_action == "drawer") {
        this.initializeAjaxCart();
      } else {
        this.initializeAjaxCartOnMobile();
      }

      if (this.cart_action == "drawer") {
        this.ajaxCartDrawer = $("[data-ajax-cart-drawer]");

        $(document).on("click", "[data-ajax-cart-trigger]", function (e) {
          e.preventDefault();
          Shopify.theme.jsAjaxCart.showDrawer();

          return false;
        });
      } else if (this.cart_action == "mini_cart") {
        this.showMiniCartOnHover();
      }

      $(document).off("click.sbAddToCart", ".ajax-submit").on("click.sbAddToCart", ".ajax-submit", function (e) {
        e.preventDefault();
        const $addToCartForm = $(this).closest("form");
        Shopify.theme.jsAjaxCart.addToCart($addToCartForm);

        return false;
      });

      $(document).on("click", "[data-ajax-cart-delete]", function (e) {
        e.preventDefault();
        const lineID = $(this).parents("[data-line-item]").attr("data-line-item");
        Shopify.theme.jsAjaxCart.removeFromCart(lineID);

        return false;
      });

      $(document).on("click", "[data-ajax-cart-close]", function (e) {
        e.preventDefault();
        Shopify.theme.jsAjaxCart.hideDrawer();
        Shopify.theme.jsAjaxCart.hideMiniCart();

        return false;
      });

      if (window.sbCartSubmitGuard) {
        window.sbCartSubmitGuard.ready(function (form, data) {
          return Shopify.theme.jsAjaxCart.addToCart($(form), data);
        });
      }
    },
    showMiniCartOnHover: function () {
      const $el = $("[data-ajax-cart-trigger]");

      $el.hover(
        function () {
          if (
            Shopify.theme_settings.header_layout == "centered" &&
            $(".header-sticky-wrapper").hasClass("is-sticky")
          ) {
            $(".header-sticky-wrapper [data-ajax-cart-trigger]").addClass(
              "show-mini-cart"
            );
          } else {
            $el.addClass("show-mini-cart");
          }
        },
        function () {
          $el.removeClass("show-mini-cart");
        }
      );
    },
    hideMiniCart: function () {
      if (this.cart_action != "mini_cart") return false;
      const $el = $("[data-ajax-cart-close]").parents(
        "[data-ajax-cart-trigger]"
      );
      $el.removeClass("show-mini-cart");
    },
    toggleMiniCart: function () {
      const $el = $(".mobile-header [data-ajax-cart-trigger]");

      // Removes url to the cart page so user is not redirected
      $el.attr("href", "#");

      $el.off("touchstart").on("touchstart", function (e) {
        // If user clicks inside the element, do nothing
        if (e.target.closest("[data-ajax-cart-mini_cart]")) {
          return;
        }

        // Loads content into ajaxCart container for mobile header
        Shopify.theme.jsAjaxCart.initializeAjaxCartOnMobile();

        // If user clicks outside the element, toggle the mini cart
        $el.toggleClass("show-mini-cart");
      });
    },
    showDrawer: function () {
      if (this.cart_action != "drawer") return false;
      this.ajaxCartDrawer.addClass("is-visible");
      $(".ajax-cart__overlay").addClass("is-visible");
      $("html").addClass("cart-drawer-open");
    },
    hideDrawer: function () {
      if (this.cart_action != "drawer") return false;
      this.ajaxCartDrawer.removeClass("is-visible");
      $(".ajax-cart__overlay").removeClass("is-visible");
      $("html").removeClass("cart-drawer-open");
    },
    removeFromCart: function (lineID, callback) {
      $.ajax({
        type: "POST",
        url: "/cart/change.js",
        data: "quantity=0&line=" + lineID,
        dataType: "json",
        success: function (cart) {
          if (window.SleepybellyOpenAIAds) window.SleepybellyOpenAIAds.cartUpdated(cart, false);
          // Use the surgical update path. The previous unconditional
          // updateView() call burned a 470ms /cart?view=ajax fetch just to
          // delete a row we can simply remove from the DOM. applyCartJson
          // handles empty-cart state and falls back to updateView() on its
          // own if anything looks structurally off.
          if (typeof Shopify.theme.jsAjaxCart.applyCartJson === "function") {
            Shopify.theme.jsAjaxCart.applyCartJson(cart);
          } else {
            Shopify.theme.jsAjaxCart.updateView();
          }

          if (Shopify.theme.jsCart) {
            Shopify.theme.jsCart.updateView(cart, null);
          }
        },
        error: function (XMLHttpRequest) {
          if (XMLHttpRequest.status === 429) {
            console.warn("[Cart] Remove failed: rate-limited (status 429)");
            return;
          }
          try {
            var parsed = JSON.parse(XMLHttpRequest.responseText);
            console.warn(
              "[Cart] Remove failed:",
              (parsed && parsed.description) || "no description",
              "(status " + XMLHttpRequest.status + ")"
            );
          } catch (e) {
            console.warn(
              "[Cart] Remove failed with unparseable response (status " +
                XMLHttpRequest.status +
                ")",
              e
            );
          }
        },
      });
    },
    initializeAjaxCart: function () {
      Shopify.theme.asyncView
        .load(
          Shopify.routes.cart_url, // template name
          "ajax" // view name (suffix)
        )
        .done(({ html, options }) => {
          $("[data-ajax-cart-content]").html(html.content);

          // Converting the currencies
          if (Shopify.theme.currencyConverter) {
            Shopify.theme.currencyConverter.convertCurrencies();
          }
        })
        .fail(() => {
          // some error handling
        });
    },
    initializeAjaxCartOnMobile: function () {
      this.toggleMiniCart();

      Shopify.theme.asyncView
        .load(
          Shopify.routes.cart_url, // template name
          "ajax" // view name (suffix)
        )
        .done(({ html, options }) => {
          $(".mobile-header [data-ajax-cart-content]").html(html.content);
        })
        .fail(() => {
          // some error handling
        });
    },
    addToCart: function ($addToCartForm, submittedData) {
      const $addToCartBtn = $addToCartForm.find(".button--add-to-cart");

      $addToCartForm.removeClass("shopify-product-form--unselected-error");

      if ($addToCartBtn[0].hasAttribute("data-options-unselected")) {
        const cartWarning = `<p class="cart-warning__message animated bounceIn">${Shopify.translation.select_variant}</p>`;

        $(".warning").remove();

        $addToCartForm
          .addClass("shopify-product-form--unselected-error")
          .find(".cart-warning")
          .html(cartWarning);

        $addToCartBtn.removeAttr("disabled").removeClass("disabled");

        $addToCartBtn.find(".icon").removeClass("zoomOut").addClass("zoomIn");

        $addToCartBtn
          .find("span:not(.icon)")
          .text($addToCartBtn.data("label"))
          .removeClass("zoomOut")
          .addClass("zoomIn");
      } else {
        var openAIAdsFormData = submittedData === undefined ? $addToCartForm.serialize() : submittedData;
        return $.ajax({
          url: "/cart/add.js",
          dataType: "json",
          cache: false,
          type: "post",
          data: openAIAdsFormData,
          beforeSend: function () {
            $addToCartBtn.attr("disabled", "disabled").addClass("disabled");

            $addToCartBtn
              .find("span")
              .removeClass("fadeInDown")
              .addClass("animated zoomOut");
          },
          success: function (product) {
            if (window.SleepybellyOpenAIAds) window.SleepybellyOpenAIAds.cartAdded(product, openAIAdsFormData);
            let $el = $("[data-ajax-cart-trigger]");

            $addToCartBtn.find(".checkmark").addClass("checkmark-active");

            function addedToCart() {
              if (!isScreenSizeLarge()) {
                $el = $(".mobile-header [data-ajax-cart-trigger]");
                Shopify.theme.scrollToTop($el);
              } else {
                $el = $("[data-ajax-cart-trigger]");
              }

              $el.addClass("show-mini-cart");

              $addToCartBtn.find("span").removeClass("fadeInDown");
            }

            // Lowered from 1000ms to 350ms. The drawer already opens and
            // updates immediately below — this timer only governs how long
            // the source button shows its "checkmark" success state, which
            // doesn't need to feel as deliberate as the previous full second.
            window.setTimeout(function () {
              $addToCartBtn.removeAttr("disabled").removeClass("disabled");

              $addToCartBtn.find(".checkmark").removeClass("checkmark-active");

              $addToCartBtn
                .find(".text, .icon")
                .removeClass("zoomOut")
                .addClass("fadeInDown");

              $addToCartBtn.on(
                "webkitAnimationEnd oanimationend msAnimationEnd animationend",
                addedToCart
              );
            }, 350);

            Shopify.theme.jsAjaxCart.showDrawer();
            Shopify.theme.jsAjaxCart.updateView();
          },
          error: function (XMLHttpRequest) {
            var message;
            if (XMLHttpRequest.status === 429) {
              message =
                "Too many requests. Please wait a moment and try again.";
            } else {
              // /cart/add.js error bodies are JSON regardless of
              // content-type — Shopify uses application/json from core
              // and text/javascript when a Function rejects the line.
              // Parse either way so customers see Shopify's actual
              // description instead of a misleading rate-limit message.
              try {
                var parsed = JSON.parse(XMLHttpRequest.responseText);
                message = (parsed && parsed.description) || "Unable to add to cart.";
              } catch (e) {
                message = "Unable to add to cart.";
              }
            }

            const cartWarning = `<p class="cart-warning__message animated bounceIn">${message.replace(
              "All 1 ",
              "All "
            )}</p>`;

            $(".warning").remove();

            $addToCartForm.find(".cart-warning").html(cartWarning);

            $addToCartBtn.removeAttr("disabled").removeClass("disabled");

            $addToCartBtn
              .find(".icon")
              .removeClass("zoomOut")
              .addClass("zoomIn");

            $addToCartBtn
              .find("span:not(.icon)")
              .text($addToCartBtn.data("label"))
              .removeClass("zoomOut")
              .addClass("zoomIn");
          },
        });
      }
    },
    updateView: function () {
      var now = Date.now();
      if (this._updateViewInFlight) {
        var inFlightAge = now - (this._updateViewStartedAt || now);
        if (inFlightAge > 75) {
          this._updateViewQueued = true;
        }
        return this._updateViewInFlight;
      }

      this._updateViewStartedAt = Date.now();
      this._updateViewInFlight = Shopify.theme.asyncView
        .load(
          Shopify.routes.cart_url, // template name
          "ajax" // view name (suffix)
        )
        .done(({ html, options }) => {
          if (options.item_count > 0) {
            const itemList = $(html.content).find(".ajax-cart__list");
            const cartDetails = $(html.content).find(
              ".ajax-cart__details-wrapper"
            );
            $(".ajax-cart__list").replaceWith(itemList);
            $(".ajax-cart__details-wrapper").replaceWith(cartDetails);
            $(".ajax-cart__empty-cart-message").addClass("is-hidden");
            $(".ajax-cart__form").removeClass("is-hidden");
            $("[data-ajax-cart-trigger]").addClass("has-cart-count");
            $('[data-bind="itemCount"]').text(options.item_count);

          } else {
            $(".ajax-cart__empty-cart-message").removeClass("is-hidden");
            $(".ajax-cart__form").addClass("is-hidden");
            $("[data-ajax-cart-trigger]").removeClass("has-cart-count");
            $('[data-bind="itemCount"]').text("0");
          }

          if (Shopify.theme.currencyConverter) {
            Shopify.theme.currencyConverter.convertCurrencies();
          }
        })
        .fail(() => {
          // some error handling
        })
        .always(() => {
          this._updateViewInFlight = null;
          this._updateViewStartedAt = null;

          if (this._updateViewQueued) {
            this._updateViewQueued = false;
            this.updateView();
          }
        });

      return this._updateViewInFlight;
    },
    // Phase 1 surgical update: rewrites only the line/cart subtotals and the
    // count badge in place using the JSON returned from /cart/change.js.
    // Skips the 470ms round-trip + 63KB HTML payload of /cart?view=ajax.
    // Falls back to updateView() whenever the DOM structure could be stale
    // (item count change, key mismatch, empty cart) so that line additions or
    // removals (including DealEasy free-gift swaps) still render correctly.
    applyCartJson: function (cart) {
      if (!cart || typeof cart !== "object") {
        Shopify.theme.jsAjaxCart.updateView();
        return;
      }

      var escapeKey = function (k) {
        return window.CSS && CSS.escape ? CSS.escape(k) : k;
      };

      // Empty cart: handle in place. Previously this fell through to a full
      // /cart?view=ajax fetch (~470ms) just to swap to the empty state — but
      // the empty state markup is already in the DOM, just hidden.
      if (
        cart.item_count === 0 ||
        !cart.items ||
        cart.items.length === 0
      ) {
        $(".ajax-cart__list .ajax-cart__product").remove();
        $(".ajax-cart__empty-cart-message").removeClass("is-hidden");
        $(".ajax-cart__form").addClass("is-hidden");
        $("[data-ajax-cart-trigger]").removeClass("has-cart-count");
        $('[data-bind="itemCount"]').text(0);
        return;
      }

      // Compare the SET of unique line keys in the DOM with cart.items —
      // catches DealEasy gift swaps and line key churn without false positives
      // from duplicate rows.
      var domKeys = {};
      var domKeyCount = 0;
      document
        .querySelectorAll(".ajax-cart__list [data-cart-item]")
        .forEach(function (n) {
          var k = n.getAttribute("data-cart-item");
          if (k && !domKeys[k]) {
            domKeys[k] = true;
            domKeyCount++;
          }
        });

      // Line ADDED (cart has more items than DOM): we don't have rendered
      // HTML for the new line client-side, so fall back to a server render.
      // Could be optimized later with Shopify's `sections=` param on
      // /cart/add.js to get HTML back in the same response.
      if (domKeyCount < cart.items.length) {
        Shopify.theme.jsAjaxCart.updateView();
        return;
      }

      for (var i = 0; i < cart.items.length; i++) {
        if (!domKeys[cart.items[i].key]) {
          Shopify.theme.jsAjaxCart.updateView();
          return;
        }
      }

      // Line REMOVED (DOM has more items than cart): find which keys vanished
      // and remove them in place. Saves the 470ms server round trip on every
      // delete click.
      if (domKeyCount > cart.items.length) {
        var cartKeys = {};
        for (var k = 0; k < cart.items.length; k++) {
          cartKeys[cart.items[k].key] = true;
        }
        Object.keys(domKeys).forEach(function (key) {
          if (!cartKeys[key]) {
            $('[data-cart-item="' + escapeKey(key) + '"]').remove();
          }
        });
      }

      for (var j = 0; j < cart.items.length; j++) {
        var item = cart.items[j];
        var $line = $(
          '[data-cart-item="' + escapeKey(item.key) + '"]'
        );

        $line.find(".ajax-cart__price.price .money:not(.compare-at-price)").each(function () {
          Shopify.theme.jsAjaxCart._writeMoneyPreservingFormat(
            this,
            typeof item.final_line_price !== "undefined"
              ? item.final_line_price
              : item.line_price
          );
        });

        // Each cart line can match multiple DOM nodes; update every matching
        // qty input but never overwrite the one the user is typing in.
        $line.find(".quantity-input").each(function () {
          if (document.activeElement !== this) {
            this.value = item.quantity;
          }
        });

        $line.attr("data-line-item", j + 1);
        $line.find("[data-line-item-key]").attr("data-line-item-key", j + 1);
      }

      $(".ajax-cart__subtotal .money").each(function () {
        Shopify.theme.jsAjaxCart._writeMoneyPreservingFormat(
          this,
          cart.total_price
        );
      });

      Shopify.theme.jsAjaxCart._updateSavingsFromCartJson(cart);

      $('[data-bind="itemCount"]').text(cart.item_count);

      $(".ajax-cart__empty-cart-message").addClass("is-hidden");
      $(".ajax-cart__form").removeClass("is-hidden");
      $("[data-ajax-cart-trigger]").addClass("has-cart-count");

      if (
        Shopify.theme.currencyConverter &&
        Shopify.theme.currencyConverter.isInitialised
      ) {
        Shopify.theme.currencyConverter.convertCurrencies();
      }

      // Surgical update preserves the existing Stamped badges in the DOM,
      // so we don't need to re-scan. Left here as documentation of the
      // intentional choice — calling loadBadges() on every qty change was
      // pure waste and made repeated +/– clicks feel laggy.
    },
    _updateSavingsFromCartJson: function (cart) {
      if (!cart || !cart.items || !cart.items.length) return;

      var escapeKey = function (k) {
        return window.CSS && CSS.escape ? CSS.escape(k) : k;
      };
      var totalValue = 0;

      for (var i = 0; i < cart.items.length; i++) {
        var item = cart.items[i];
        var finalLinePrice =
          typeof item.final_line_price !== "undefined"
            ? item.final_line_price
            : item.line_price || 0;
        var lineValue = item.original_line_price || finalLinePrice;
        var $line = $('[data-cart-item="' + escapeKey(item.key) + '"]').first();
        var compareAtCents = Shopify.theme.jsAjaxCart._readMoneyAsCents(
          $line.find(".ajax-cart__price.price .compare-at-price").first().text()
        );

        if (compareAtCents > lineValue) {
          lineValue = compareAtCents;
        }

        totalValue += lineValue;
      }

      var savings = totalValue - (cart.total_price || 0);
      $(".ajax-cart__savings .money").each(function () {
        Shopify.theme.jsAjaxCart._writeMoneyPreservingFormat(
          this,
          savings > 0 ? savings : 0
        );
      });
    },
    _readMoneyAsCents: function (text) {
      var match = String(text || "").match(/[\d,]+(?:\.\d{1,2})?/);
      if (!match) return 0;

      return Math.round(parseFloat(match[0].replace(/,/g, "")) * 100);
    },
    _writeMoneyPreservingFormat: function (el, cents) {
      if (
        !el ||
        typeof Shopify === "undefined" ||
        typeof Shopify.formatMoney !== "function"
      ) {
        return;
      }
      var newAmount;
      try {
        newAmount = Shopify.formatMoney(cents, "{{amount}}");
      } catch (e) {
        return;
      }
      var oldText = el.textContent;
      var priceRe = /[\d,]+(?:\.\d{1,2})?/;
      if (priceRe.test(oldText)) {
        el.textContent = oldText.replace(priceRe, newAmount);
      } else {
        try {
          el.textContent = Shopify.formatMoney(cents);
        } catch (e2) {}
      }
    },
    unload: function ($section) {
      // Clear event listeners in theme editor
      $(".ajax-submit").off();
      $("[data-ajax-cart-delete]").off();
    },
  };

  /******/
})();

function hideAddedProducts() {
  $.ajax({
    type: "GET",
    url: "/cart.js",
    dataType: "json",
    success: function (cart) {
      var cartItems = cart.items || [];

      $(".ajax-cart-upsell-products-item").each(function () {
        var $upsell = $(this);
        var upsellVariantId = Number($upsell.data("variant-id"));

        // If upsell has no variant ID → DO NOT REMOVE IT
        if (!upsellVariantId) return;

        var isInCart = cartItems.some(function (item) {
          return item.variant_id === upsellVariantId;
        });

        if (isInCart) {
          $upsell.hide();
        }
      });
    },
  });
}


$(document).on("change", ".ajax-cart-upsell-products-variant", function () {
  var SelectedVar = $(this).find(":selected").val();
  var check_avail = $(this).find(":selected").attr("var-avail");
  
  var SelectedPro = $(this).find(":selected").attr("data-id");
  $(".custom-add-btn-" + SelectedPro).attr("data-id", SelectedVar);
  if(check_avail == 'false'){
    $(this).parents(".ajax-cart-upsell-products-right").find(".ajax-cart-upsell-products-right-inner-right a").text("Sold Out");
    $(this).parents(".ajax-cart-upsell-products-right").find(".ajax-cart-upsell-products-right-inner-right").addClass("disabled");
  }else{
    $(this).parents(".ajax-cart-upsell-products-right").find(".ajax-cart-upsell-products-right-inner-right a").text("Add to Order");
    $(this).parents(".ajax-cart-upsell-products-right").find(".ajax-cart-upsell-products-right-inner-right").removeClass("disabled");
  }
});

$(document).on("click", ".custom-add-btn", function () {
  var VarId = $(this).attr("data-id");
  var data = {
    id: VarId,
    quantity: 1,
  };
  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    dataType: "json",
    data: data,
    success: function (product) {
      if (window.SleepybellyOpenAIAds) window.SleepybellyOpenAIAds.cartAdded(product, data);
      Shopify.theme.jsAjaxCart.updateView();
      // hideAddedProducts() removed — it was firing an extra GET /cart.js
      // per upsell add but reading the wrong data attribute (variant-id vs
      // product-id), so it never hid anything anyway.
      setTimeout(function () {
        $(".header-cart").trigger("click");
      }, 90);
    },
    error: function (XMLHttpRequest) {
      if (XMLHttpRequest.status === 429) {
        console.warn("[Cart] Upsell add failed: rate-limited (status 429)");
        return;
      }
      var msg = "Unable to add upsell to cart.";
      try {
        var parsed = JSON.parse(XMLHttpRequest.responseText);
        if (parsed && (parsed.description || parsed.message)) {
          msg = parsed.description || parsed.message;
        }
      } catch (e) {}
      console.warn(
        "[Cart]",
        msg,
        "(status " + XMLHttpRequest.status + ")"
      );
    },
  });
});

function reRenderPrices() {
  /* --- For themes using Shopify Price UI --- */
  if (window.Shopify && Shopify.theme && Shopify.theme.priceUI) {
    try {
      Shopify.theme.priceUI.init();
    } catch (e) {}
  }

  /* --- For themes using productStrings (some older themes) --- */
  if (window.Shopify && Shopify.theme && Shopify.theme.productStrings) {
    if (typeof Shopify.theme.productStrings.initializeMoneyFormat === "function") {
      Shopify.theme.productStrings.initializeMoneyFormat();
    }
  }

  /* --- Fallback for themes using data-price --- */
  if (window.Shopify && Shopify.formatMoney) {
    $("[data-price]").each(function () {
      var price = $(this).attr("data-price");
      if (price) {
        $(this).html(Shopify.formatMoney(price));
      }
    });
  }

  /* --- MULTI-CURRENCY FIX (if your theme uses converter) --- */
  if (Shopify.theme.currencyConverter) {
    try {
      Shopify.theme.currencyConverter.convertCurrencies();
    } catch (e) {}
  }
}


let updateTimeout;

function debounceCartUpdate(callback) {
  clearTimeout(updateTimeout);
  updateTimeout = setTimeout(callback, 250); // FAST + smooth
}



function updateUpsellVariants(cart) {
    const cartVariantsInCart = cart.items.map(item => item.variant_id);

    const upsellSelectors = document.querySelectorAll('.ajax-cart-upsell-products-variant');

    upsellSelectors.forEach(select => {
        Array.from(select.options).forEach(option => {
            const variantId = parseInt(option.value);
            if (cartVariantsInCart.includes(variantId)) {
                option.disabled = true;
                option.text = option.text.replace(" (Added)", "") + " (Added)";
            } else {
                option.disabled = false;
                option.text = option.text.replace(" (Added)", "");
            }
        });
    });
}
// REMOVED: orphaned $.post('/cart/add.js', { id: selectedVariantId, ... })
// at module scope. `selectedVariantId` was never declared anywhere, so this
// fired POST /cart/add.js?id=undefined on EVERY page load, wasting one cart
// API call per pageview and contributing to 429 rate limits when combined
// with DealEasy + other apps polling the cart.
// The updateUpsellVariants() function above is left in place in case it is
// wired into a real upsell event handler in the future.

/* ---------------------------------------------------------------------------
   Cart drawer "updating" state. On each shopper cart change (qty step,
   remove, add) dim the drawer content and show a subtle spinner for a
   fixed ~1s, so the cart's update lag reads as deliberate rather than
   janky. A fixed duration — rather than clearing the moment the drawer
   re-renders — keeps the spinner from flashing off too quickly when the
   re-render happens fast.
--------------------------------------------------------------------------- */
(function () {
  if (typeof jQuery === "undefined") return;
  var $ = jQuery;
  var capTimer = null;

  // Show the "updating" state for a fixed 1s, restarting the timer on each
  // successive click so rapid changes hold it steady rather than flicker.
  function showUpdating() {
    var $content = $("[data-ajax-cart-content]");
    $content.addClass("is-updating");
    if (capTimer) clearTimeout(capTimer);
    capTimer = setTimeout(function () {
      $content.removeClass("is-updating");
      capTimer = null;
    }, 1000);
  }

  // The shopper triggered a cart change (qty step, remove, add).
  $(document).on(
    "click",
    ".quantity-plus, .quantity-minus, [data-ajax-cart-delete], .custom-add-btn, .ajax-submit",
    showUpdating
  );
})();
